import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCart } from "../../components/CartContext";

import "./css/CartScreen.css";


function CartScreen() {

  const navigate = useNavigate();

  const {
    restaurantId,
    tableId,
  } = useParams();

  const {
    cart,
    cartCount,
    cartTotal,
    increaseQuantity,
    decreaseQuantity,
    removeFromCart,
  } = useCart();


  // ==========================================
  // Back to Menu
  // ==========================================

  const handleBackToMenu = () => {
    navigate(
      `/${restaurantId}/table/${tableId}`
    );
  };


  // ==========================================
  // Continue Order
  // ==========================================

  const handleContinueOrder = () => {

    navigate(
      `/${restaurantId}/table/${tableId}/checkout`
    );

  };


  // ==========================================
  // Empty Cart
  // ==========================================

  if (cart.length === 0) {

    return (

      <div className="cart-page">

        <div className="cart-container">

          {/* Header */}

          <div className="cart-header">

            <button
              type="button"
              className="cart-back-button"
              onClick={handleBackToMenu}
            >
              ← Back to Menu
            </button>

            <div className="cart-title-section">

              <h1>
                Your Cart
              </h1>

              <p>
                Your selected items
              </p>

            </div>

          </div>


          {/* Empty Cart */}

          <div className="cart-empty">

            <div className="cart-empty-icon">
              🛒
            </div>

            <h2>
              Your cart is empty
            </h2>

            <p>
              Please add some items from the menu.
            </p>

            <button
              type="button"
              className="cart-browse-button"
              onClick={handleBackToMenu}
            >
              Browse Menu
            </button>

          </div>

        </div>

      </div>

    );

  }


  // ==========================================
  // Cart
  // ==========================================

  return (

    <div className="cart-page">

      <div className="cart-container">


        {/* =====================================
            Header
        ====================================== */}

        <div className="cart-header">

          <button
            type="button"
            className="cart-back-button"
            onClick={handleBackToMenu}
          >
            ← Back to Menu
          </button>


          <div className="cart-title-section">

            <h1>
              Your Cart
            </h1>

            <p>
              {cartCount}{" "}
              {cartCount === 1
                ? "item"
                : "items"}
            </p>

          </div>

        </div>


        {/* =====================================
            Cart Items
        ====================================== */}

        <div className="cart-items">

          {cart.map((item) => {

            const price =
              Number(item.price);

            const itemTotal =
              price * item.quantity;


            return (

              <div
                className="cart-item"
                key={item.id}
              >


                {/* Product Image */}

                <div className="cart-item-image-wrapper">

                  <img
                    src={item.image}
                    alt={item.name}
                    className="cart-item-image"
                  />

                </div>


                {/* Product Details */}

                <div className="cart-item-details">

                  <h3>
                    {item.name}
                  </h3>


                  {item.description && (

                    <p>
                      {item.description}
                    </p>

                  )}


                  <span className="cart-item-price">

                    ₹{price.toFixed(2)}

                  </span>

                </div>


                {/* Actions */}

                <div className="cart-item-actions">


                  {/* Quantity */}

                  <div className="cart-quantity">

                    <button
                      type="button"
                      onClick={() =>
                        decreaseQuantity(item.id)
                      }
                    >
                      −
                    </button>


                    <span>
                      {item.quantity}
                    </span>


                    <button
                      type="button"
                      onClick={() =>
                        increaseQuantity(item.id)
                      }
                    >
                      +
                    </button>

                  </div>


                  {/* Item Total */}

                  <strong className="cart-item-total">

                    ₹{itemTotal.toFixed(2)}

                  </strong>


                  {/* Remove */}

                  <button
                    type="button"
                    className="cart-remove-button"
                    onClick={() =>
                      removeFromCart(item.id)
                    }
                  >
                    Remove
                  </button>

                </div>

              </div>

            );

          })}

        </div>


        {/* =====================================
            Summary
        ====================================== */}

        <div className="cart-summary">


          <div className="cart-summary-row">

            <span>
              Items
            </span>

            <span>
              {cartCount}
            </span>

          </div>


          <div className="cart-summary-row">

            <span>
              Subtotal
            </span>

            <span>
              ₹{Number(cartTotal).toFixed(2)}
            </span>

          </div>


          <div className="cart-summary-divider" />


          <div className="cart-summary-total">

            <span>
              Total
            </span>

            <strong>
              ₹{Number(cartTotal).toFixed(2)}
            </strong>

          </div>


          {/* Continue */}

          <button
            type="button"
            className="continue-order-button"
            onClick={handleContinueOrder}
          >

            Continue Order

            <span>
              →
            </span>

          </button>

        </div>

      </div>

    </div>

  );
}

export default CartScreen;